module.exports = __webpack_public_path__ + "media/bootstrap-icons/droplet-703d1a26.svg";